export const EnterCustomFieldsModalTestIds = {
  CANCEL_BUTTON: 'enter-custom-fields-modal.cancel-button',
  SUBMIT_BUTTON: 'enter-custom-fields-modal.submit-button',
};
